module.exports = __webpack_public_path__ + "static/media/star_black_and_white.2b9242f0.png";